import { User, UserManager, WebStorageStateStore } from "oidc-client-ts";

export const userManager: UserManager = new UserManager({
  authority: process.env.REACT_APP_OIDC_AUTHORITY as string,
  client_id: process.env.REACT_APP_OIDC_CLIENT_ID as string,
  client_secret: process.env.REACT_APP_OIDC_CLIENT_SECRET as string,
  client_authentication: "client_secret_post",

  redirect_uri: process.env.REACT_APP_OIDC_REDIRECT_URI as string,
  post_logout_redirect_uri: process.env.REACT_APP_OIDC_LOGOUT_REDIRECT_URI as string,

  response_type: 'code',
  scope: 'profile openid',
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  stateStore: new WebStorageStateStore({ store: window.sessionStorage }),

  revokeTokensOnSignout: true,
  revokeTokenTypes: ['access_token', 'refresh_token'],
});

const cleanupOidcState = () => {
  const keysToRemove: string[] = [];
  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i);
    if (key && key.startsWith('oidc.')) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach(key => sessionStorage.removeItem(key));
};

export const onSignInCallback = (): void => {
  const hash = window.location.hash;
  const pathname = window.location.pathname;
  window.location.replace(pathname + hash);
};

export const logoutRedirect = () => {
  const user = getOidcUser();
  const logoutUrl = new URL(`${process.env.REACT_APP_OIDC_AUTHORITY}/connect/logout`);

  if (user?.id_token) {
    logoutUrl.searchParams.append('id_token_hint', user.id_token);
  }

  if (process.env.REACT_APP_OIDC_LOGOUT_REDIRECT_URI) {
    logoutUrl.searchParams.append('post_logout_redirect_uri', process.env.REACT_APP_OIDC_LOGOUT_REDIRECT_URI);
  }

  sessionStorage.clear();
  localStorage.clear();

  window.location.href = logoutUrl.toString();
};

export const getOidcUser = (): User | undefined => {
  const oidcAuthority: string = process.env.REACT_APP_OIDC_AUTHORITY as string;
  const oidcClientId: string = process.env.REACT_APP_OIDC_CLIENT_ID as string;
  const oidcSessionStorage: string | null = sessionStorage.getItem(`oidc.user:${oidcAuthority}:${oidcClientId}`);
  if (!oidcSessionStorage) {
    return undefined;
  }
  return User.fromStorageString(oidcSessionStorage);
};